<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent" :style="{color: d.dialogTextColor,
        'background-color': d.dialogBgColor}">
        <div class="close" v-on:click="close(false)"></div>
        <div class="dialogHeaderImgCnt" v-if="d.dialogHeaderImgs && d.dialogHeaderImgs.length > 0">
          <div class="dialogHeaderNav" v-if="d.dialogHeaderImgs.length > 1">
            <div class="navItem prev" v-on:click="hdImgIdx -= 1"
              v-if="hdImgIdx > 0"></div>
            <div class="navItem next" v-on:click="hdImgIdx += 1"
              v-if="hdImgIdx < d.dialogHeaderImgs.length - 1"></div>
          </div>
          <div class="dialogHeaderImgSc" :style="{width: `${d.dialogHeaderImgs.length * 100}%`}"
            :class="`idx${hdImgIdx}`">
            <img class="dialogHeaderImg" v-for="(img, i) in d.dialogHeaderImgs" :key="`hdIm${i}`"
              :style="{width: `${100 / d.dialogHeaderImgs.length}%`}"
              :src="img.media && img.media[lang] ? img.media[lang].imageLg : ''">
          </div>
        </div>
        <h4 v-if="d.dialogTitle[lang]">{{d.dialogTitle[lang]}}</h4>
        <p v-if="d.dialogDesc[lang]">{{d.dialogDesc[lang]}}</p>
        <div class="btnCnt" v-if="d.dialogLink && d.dialogLink.length > 0">
          <div class="btnWrapper" v-for="(item, i) in d.dialogLink" :key="`dbtn${i}`">
            <button class="btn primary" v-if="item.url[lang] === ':close'"
              v-on:click="close(false)">{{item.name[lang]}}</button>
            <a :href="item.url[lang]" v-else class="btn primary" target="_blank">{{item.name[lang]}}</a>
          </div>
        </div>
        <div class="socmedCnt" v-if="d.dialogDisplaySocmed && socmed">
          <h3>{{socmed.footerSocmedLabel[lang]}}</h3>
          <p>{{socmed.footerSocmedDesc[lang]}}</p>
          <div class="media-sosial-icon-container mt-2">
            <div class="media-sosial-icon" v-for="(item, i) in socmed.socmed" :key="`sc${i}`">
              <a :href="item.url" target="_blank" :title="item.name">
                <img :src="item.media.imageSm">
              </a>
            </div>
          </div>
        </div>
        <div class="formCnt" v-if="d.dialogDisplayForm">
          <form v-on:submit.prevent="handleSubmit">
            <div class="fieldGroup" v-for="(item, i) in d.dialogFormField" :key="`f${i}`"
              :class="{hasError: item.error && item.error[lang]}">
              <label v-if="item.label && item.label[lang]">{{item.label[lang]}}
                <template v-if="item.isRequired">*</template></label>
              <div class="fieldCnt" v-if="['text', 'email', 'date'].includes(item.type)">
                <input :type="item.type" class="field" :placeholder="item.placeholder[lang]"
                  v-model="item.model[lang]" v-on:input="item.error[lang] = null">
              </div>
              <div class="fieldCnt" v-else-if="item.type === 'textarea'">
                <textarea class="field" :placeholder="item.placeholder[lang]" rows="3"
                  v-model="item.model[lang]" v-on:input="item.error[lang] = null"></textarea>
              </div>
              <div class="fieldCnt" v-else-if="item.type === 'checkbox'">
                <div class="ckCnt" v-for="(opt, i2) in item.options" :key="`ck${i2}`">
                  <label>
                    <input type="checkbox" v-model="opt.selected"
                      v-on:change="item.error[lang] = null">
                    <span class="checkmark"></span>
                    {{opt.label}}
                  </label>
                </div>
              </div>
              <div class="fieldCnt" v-else-if="['select', 'dropdown'].includes(item.type)">
                <select class="field" v-model="item.model[lang]"
                  v-on:change="item.error[lang] = null">
                  <option value="__placeholder__" v-if="item.placeholder[lang]">
                    {{item.placeholder[lang]}}
                  </option>
                  <option v-for="(opt, i2) in item.options" :key="`ck${i2}`">
                    {{opt.label}}
                  </option>
                </select>
              </div>
              <div class="fieldError" v-if="item.error && item.error[lang]">
                {{item.error[lang]}}
              </div>
            </div>
            <button class="btn primary" type="submit">
              {{d.dialogSubmitLabel[lang]}}
            </button>
          </form>
        </div>
      </div>
      <ThankYou ref="thankYou"/>
    </div>
  </transition>
</template>

<script>
import ThankYou from '@/components/ThankYou.vue';

export default {
  name: 'welcomeDialog',
  components: { ThankYou },
  data() {
    return {
      show: false,
      next: null,
      d: null,
      socmed: null,
      hdImgIdx: 0,

      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    open(d, next) {
      this.next = next;
      this.d = d;
      this.show = true;

      /**
       * Get social media data
       *
       */
      if (d.dialogDisplaySocmed) {
        this.$http.get(this.$config.uri('config/section/socmed')).then((r) => {
          this.socmed = r.data.status === 200 ? r.data.data : null;
        });
      }
    },
    close(b) {
      this.show = false;
      if (this.next) this.next(b);
    },
    resetForm() {
      // eslint-disable-next-line
      for (const item of this.d.dialogFormField) {
        if (['select', 'dropdown'].includes(item.type)) {
          item.model[this.lang] = '__placeholder__';
        } else if (item.type === 'checkbox') {
          // eslint-disable-next-line
          for (const opt of item.options) {
            opt.selected = false;
          }
        } else {
          item.model[this.lang] = '';
        }
      }
    },
    handleSubmit() {
      const formData = {
        title: this.d.dialogTitle,
        descriptions: this.d.dialogDesc,
        emailVerification: this.d.dialogEmailVerification,
        lang: this.lang,
        items: [],
      };
      // eslint-disable-next-line
      for (const item of this.d.dialogFormField) {
        if (item.isRequired) {
          if (['select', 'dropdown'].includes(item.type)) {
            if (!item.model[this.lang] || item.model[this.lang] === '__placeholder__') {
              item.error.id = 'Pilihan harus dipilih';
              item.error.en = 'Field is required';
              return;
            }
          } else if (item.type === 'checkbox') {
            let hasSelected = false;
            // eslint-disable-next-line
            for (const opt of item.options) {
              if (opt.selected) hasSelected = true;
            }
            if (!hasSelected) {
              item.error.id = 'Pilihan harus dipilih';
              item.error.en = 'Field is required';
              return;
            }
          } else if (!item.model[this.lang] || item.model[this.lang].trim() === '') {
            item.error.id = 'Masukan harus diisi';
            item.error.en = 'Field is required';
            return;
          }
        }

        formData.items.push({
          type: item.type,
          isRequired: item.isRequired,
          label: item.label[this.lang],
          model: item.model[this.lang],
          placeholder: item.placeholder[this.lang],
          options: item.options,
        });
      }
      this.$refs.thankYou.open({
        loading: true,
        title: this.d.dialogSuccessTitle[this.lang],
        desc: this.d.dialogSuccessDesc[this.lang],
      });
      this.$http.post(this.$config.uri('user/form/submit'), formData).then((r) => {
        this.$refs.thankYou.stopLoading();
        this.resetForm();
      });
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.modal{
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  z-index: 991;
  display: flex;
  align-items: center;
  justify-content: center;
  .modalOverlay{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0,0,0,.7);
    z-index: 1;
    // backdrop-filter: saturate(180%) blur(20px);
    opacity: 1;
  }
  .modalContent{
    position: absolute;
    background-color: #fff;
    z-index: 2;
    padding: 30px 40px 40px;
    border-radius: 7px;
    margin-top: -20px;
    text-align: center;
    width: 520px;
    box-sizing: border-box;
    max-height: 84vh;
    overflow: auto;
    @media (max-width: 680px) {
      width: calc(100% - 20px);
      box-sizing: border-box;
      padding: 30px 20px;
    }
    .close{
      // background-color: red;
      // opacity: 1;
      // background-image: url(../assets/close-white.png);
      // width: 24px; height: 24px;
      background-size: 10px auto;
      right: 6px; top: 6px;
      width: 30px; height: 30px;
      background-color: #fff;
      opacity: .64;
      &:hover{
        opacity: 1;
      }
    }
    .dialogHeaderImgCnt{
      border-radius: 7px 7px 0 0;
      margin: -30px -40px 20px;
      overflow: hidden;
      background-color: #eee;
      position: relative;
      @media (max-width: 680px) {
        margin: -30px -20px 20px;
      }
      .dialogHeaderNav{
        .navItem{
          position: absolute;
          width: 34px; height: 34px;
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 50%;
          background-color: #fff;
          top: 50%;
          margin-top: -17px;
          opacity: .56;
          cursor: pointer;
          transition: all .3s ease;
          &:hover{
            opacity: 1;
            box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
          }
          &.prev{
            left: 16px;
            background-image: url(../assets/arrow-left-black.png);
          }
          &.next{
            right: 20px;
            background-image: url(../assets/arrow-right-black.png);
          }
        }
      }
      .dialogHeaderImgSc{
        display: flex;
        align-items: center;
        transition: all .3s ease;
        &.idx1{
          margin-left: -100%;
        }
        &.idx2{
          margin-left: -200%;
        }
        &.idx3{
          margin-left: -300%;
        }
        &.idx4{
          margin-left: -400%;
        }
        &.idx5{
          margin-left: -500%;
        }
        &.idx6{
          margin-left: -600%;
        }
        &.idx7{
          margin-left: -700%;
        }
        &.idx8{
          margin-left: -800%;
        }
        &.idx9{
          margin-left: -900%;
        }
        &.idx10{
          margin-left: -1000%;
        }
        &.idx11{
          margin-left: -1100%;
        }
        &.idx12{
          margin-left: -1200%;
        }
        &.idx13{
          margin-left: -1300%;
        }
        &.idx14{
          margin-left: -1400%;
        }
        &.idx15{
          margin-left: -1500%;
        }
        &.idx16{
          margin-left: -1600%;
        }
        &.idx17{
          margin-left: -1700%;
        }
        &.idx18{
          margin-left: -1800%;
        }
        &.idx19{
          margin-left: -1900%;
        }
        &.idx20{
          margin-left: -2000%;
        }
      }
    }
    .dialogHeaderImg{
      width: 100%;
      background-color: #eee;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      // border-radius: 7px 7px 0 0;
      // margin: -30px -40px 20px;
      // width: calc(100% + 80px);
      // border-radius: 7px;
      // margin: 0 0 20px;
      display: block;
      @media (max-width: 680px) {
        // margin: -30px -20px 20px;
        // width: calc(100% + 40px);
      }
    }
    h4{
      font-size: 26px;
      margin: 0;
      @media (max-width: 680px) {
        font-size: 24px;
      }
    }
    p{
      margin: 0;
      font-size: 15px;
      line-height: 1.3;
    }
    .btnCnt{
      padding: 20px 0 0;
      display: flex;
      justify-content: center;
      .btnWrapper{
        padding: 0 6px 6px;
      }
    }
    .socmedCnt{
      padding: 20px 0 0;
      h3{
        margin: 0;
        font-size: 18px;
        @media (max-width: 1480px) {
          font-size: 17px;
        }
      }
      p{
        font-size: 16px;
        margin: 0;
        @media (max-width: 1480px) {
          font-size: 15px;
        }
      }
      .media-sosial-icon-container{
        display: flex;
        justify-content: center;
        padding: 10px 0 0;
        .media-sosial-icon{
          font-size: 30px;
          margin: 0 5px;
          border-radius: 50%;
          overflow: hidden;
          img{
            height: 40px;
            display: block;
          }
        }
      }
    }
    .formCnt{
      padding: 20px 0 0;
      text-align: left;
      .fieldGroup{
        label{
          color: inherit;
          opacity: .76;
        }
      }
      .btn.primary{
        width: 100%;
      }
    }
  }
}
</style>
